<template>
    <div>
        <template>
            <h4 class="not-margin"
                :style="{ fontWeight: 'bold', color: '#195BFF', fontSize: '18px', textAlign: 'left' }">
                <i class="fal fa-plus-circle" :style="{ width: '25px', fontSize: '18px' }"></i>
                ເພີ່ມ ລາຄາຂົນສົ່ງ ( Shipping Rate )
            </h4>
        </template>

        <div class="columns is-multiline" :style="{ marginTop: '20px' }">
            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ປະເພດການຂົນສົ່ງ
                        <span class="text-danger">* {{ errors.first('transport_type') }}</span>
                        <span class="text-danger">{{ server_errors.transport_type }}</span>
                    </label>
                    <div class="select">
                        <select
                            class="input"
                            name="transport_type"
                            v-model="value.transport_type"
                            v-validate="'required'"
                        >
                            <option v-for="(t, i) in transportTypes" :key="i" :value="t.id">{{ t.name }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ປະເທດປາຍທາງ
                        <span class="text-danger">* {{ errors.first('address_country') }}</span>
                        <span class="text-danger">{{ server_errors.address_country }}</span>
                    </label>
                    <div class="select">
                        <select
                            class="input"
                            name="address_country"
                            v-model="value.address_country"
                            v-validate="'required'"
                        >
                            <option v-for="(c, i) in addressCountries" :key="i" :value="c.id">{{ c.name }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ລາຄາ ( ຕົວຢ່າງ: 15000/kg )
                        <span class="text-danger">* {{ errors.first('shipping_rates') }}</span>
                        <span class="text-danger">{{ server_errors.shipping_rates }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="shipping_rates"
                        placeholder="15000/kg"
                        v-model="value.shipping_rates"
                        v-validate="'required'"
                    >
                </div>
            </div>

            <div class="column is-half">
                <div class="control">
                    <label class="label">
                        ສູດຄິດໄລ່ນ້ຳໜັກ ( ຕົວຢ່າງ: L*W*H/6000 )
                        <span class="text-danger">* {{ errors.first('volumetric_weight_formula') }}</span>
                        <span class="text-danger">{{ server_errors.volumetric_weight_formula }}</span>
                    </label>
                    <input
                        type="text" class="input"
                        name="volumetric_weight_formula"
                        placeholder="L*W*H/6000"
                        v-model="value.volumetric_weight_formula"
                        v-validate="'required'"
                    >
                </div>
            </div>
        </div>

        <button
            class="button"
            :class="{ 'is-loading': btnLoading }"
            :style="{ marginTop: '20px', width: '30%' }"
            @click="ValidateForm()"
        >
            ບັນທຶກ
        </button>
    </div>
</template>

<script>
import mixinsAddShippingRate from '@coms/../../src/Mixins/Shipping-Rates/Add';
import { ValidateShipping } from '@coms/../../src/Plugins/Validation/Validate-Shipping';

export default {
    mixins: [mixinsAddShippingRate],
    created() {
        ValidateShipping(this);
    },
};
</script>

<style lang="scss" scoped>
.button {
    &:hover {
        color: $white;
    }
}
</style>
